export default __webpack_public_path__ + "static/nostalgicApe-6f0cb062cb1c4290d669f16d1283ba09.mp3";